export const API_GET_VOUCHER_ATS = "/comprobante/recibido/buscar/";
export const API_GET_SEARCH_AUTHORIZED = '/comprobante/recibido/buscar/';
export const API_PUT_UPDATE_VOUCHERS_ATS = "/comprobante/recibido/actualizar";
